import { EVENT_CONFIG } from './eventConfig';
import {
  EventDateListType,
  EventDurationType,
  EventEndDateType,
  EventGameDateWithBonusType
} from './types';

export function isValidEventAction(action: string): action is keyof typeof EVENT_CONFIG {
  return action in EVENT_CONFIG;
}

export function isEventEndDateType(
  actionsDuration: EventDurationType
): actionsDuration is EventEndDateType {
  return 'startDate' in actionsDuration;
}

export function isEventDateListType(
  actionsDuration: EventDurationType
): actionsDuration is EventDateListType {
  return 'dateList' in actionsDuration;
}

export function isEventGameDateWithBonusType(
  actionsDuration: EventDurationType
): actionsDuration is EventGameDateWithBonusType {
  return 'prodDatesWithBonuses' in actionsDuration;
}
